export default function HighlightText(params: { text: string, highlight: string }) {

    function HighlightedText() {
        if (!params.highlight) return <>{params.text}</>;

        const regex = new RegExp(`(${params.highlight})`, 'gi');
        if (!params.text) return <>{params.text}</>;

        // return "ok " + '"' + params.text + '"';
        // const text = params.text.toString().replace(/ /g, "");
        // const highlight = params.highlight.toString().replace(/ /g, "");
        const parts = params.text.toString().split(regex);

        return (
            <>
                {parts.map((part, index) =>
                    part.toLowerCase() === params.highlight.toLowerCase() ? (
                        <span key={index} style={{ fontWeight: 'bold' }}>
                            {part}
                        </span>
                    ) : (
                        part
                    )
                )}
            </>
        );
    }

    return (<>{HighlightedText()}</>)

}
